import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import baseUrl from 'Base_Url/baseUrl';
import {
  Box,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  useDisclosure,
  Icon,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
  useToast,
  Flex,
  // Select,
  Tooltip,
  IconButton,
  Skeleton,
  CloseButton,
} from '@chakra-ui/react';
import { SearchIcon, AddIcon } from '@chakra-ui/icons';
import { FaBuilding } from 'react-icons/fa';
import { FaBuildingColumns } from 'react-icons/fa6';
import Select from 'react-select';
import { useColorMode } from '@chakra-ui/react';
import { RiDeleteBin2Line } from 'react-icons/ri';
import Swal from 'sweetalert2';
import { MdEditSquare } from 'react-icons/md';

const TahsilSection = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [newTahsil, setNewTahsil] = useState('');
  const [modalDivisionId, setModalDivisionId] = useState('');
  const [modalDistrictId, setModalDistrictId] = useState('');
  const [districtId, setDistrictId] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [tahsils, setTahsils] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [modalDistricts, setModalDistricts] = useState([]);
  const toast = useToast();
  const [tahsilLoading, setTahsilLoading] = useState(false);
  const [undoTahsil, setUndoTahsil] = useState(null);
  const deleteTimeouts = useRef({});
  const { colorMode } = useColorMode();


  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: colorMode === 'dark' ? '#2D3748' : '#fff',
      color: colorMode === 'dark' ? '#fff' : '#000',
      borderColor: colorMode === 'dark' ? '#4A5568' : '#CBD5E0',
      minHeight: '32px',
      height: '32px',
      fontSize: '0.875rem',
    }),
    menu: (base) => ({
      ...base,
      background: colorMode === 'dark' ? '#1A202C' : '#fff',
      color: colorMode === 'dark' ? '#fff' : '#000',
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? colorMode === 'dark'
          ? '#2B6CB0'
          : '#3182CE'
        : state.isFocused
          ? colorMode === 'dark'
            ? '#2D3748'
            : '#E2E8F0'
          : 'transparent',
      color: colorMode === 'dark' ? '#fff' : '#000',
    }),
    singleValue: (base) => ({
      ...base,
      color: colorMode === 'dark' ? '#fff' : '#000',
    }),
    input: (base) => ({
      ...base,
      color: colorMode === 'dark' ? '#fff' : '#000',
    }),
  };

  const token = localStorage.getItem('token');

  const resetModalFields = () => {
    setNewTahsil('');
    setModalDivisionId('');
    setModalDistrictId('');
    setModalDistricts([]);
  };

  const fetchDivisions = useCallback(async () => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-divisions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const divisionsArray = res.data?.data?.data || [];
      divisionsArray.sort((a, b) => a.name.localeCompare(b.name));
      setDivisions(divisionsArray);
    } catch (err) {
      console.error('Error fetching divisions:', err);
      toast({
        title: 'Error fetching divisions',
        description: err.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [token, toast]);

  const fetchDistricts = useCallback(async () => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-districts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const districtsArray = res.data?.data?.data || [];
      districtsArray.sort((a, b) => a.name.localeCompare(b.name));
      setDistricts(districtsArray);

      if (districtsArray.length > 0) {
        setDistrictId(districtsArray[0]._id);
      }
    } catch {
      toast({
        title: 'Error fetching districts',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [token, toast]);

  const fetchTahsils = useCallback(
    async (search = '') => {
      setTahsilLoading(true);
      try {
        const res = await axios.get(`${baseUrl}/master/all-tahsils`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            search,
            districtId: districtId || undefined,
          },
        });
        let tahsilArray = res.data?.data?.data || [];
        if (districtId) {
          tahsilArray = tahsilArray.filter(
            (t) => t.district?._id === districtId,
          );
        }
        tahsilArray.sort((a, b) => a.name.localeCompare(b.name));
        setTahsils(tahsilArray);
      } catch (err) {
        console.error('Error fetching tahsils:', err);
        toast({
          title: 'Error fetching tahsils',
          description: err.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setTahsilLoading(false);
      }
    },
    [token, toast, districtId],
  );

  useEffect(() => {
    fetchDivisions();
    fetchDistricts();
  }, [fetchDivisions, fetchDistricts]);

  useEffect(() => {
    if (modalDivisionId) {
      const filtered = districts.filter(
        (d) => d.division?._id === modalDivisionId,
      );
      setModalDistricts(filtered);
    } else {
      setModalDistricts([]);
    }
  }, [modalDivisionId, districts]);

  useEffect(() => {
    if (districts.length > 0 && !districtId) {
      setDistrictId(districts[0]._id);
    }
  }, [districts, districtId]);

  useEffect(() => {
    if (modalDistricts.length > 0 && !modalDistrictId) {
      setModalDistrictId(modalDistricts[0]._id);
    }
  }, [modalDistricts, modalDistrictId]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchTahsils(searchInput);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchInput, districtId, fetchTahsils]);


  const handleSaveTahsil = async () => {
    if (!newTahsil.trim() || !modalDivisionId || !modalDistrictId) {
      toast({
        title: 'Please provide all required fields',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      if (isEditing && editingId) {
        await axios.put(
          `${baseUrl}/master/edit-tahsil/${editingId}`,
          {
            name: newTahsil.trim(),
            division: modalDivisionId,
            district: modalDistrictId,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast({
          title: 'Tahsil updated successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        await axios.post(
          `${baseUrl}/master/add-tahsil`,
          {
            name: newTahsil.trim(),
            division: modalDivisionId,
            district: modalDistrictId,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast({
          title: 'Tahsil added successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
      resetModalFields();
      onClose();
      fetchTahsils(searchInput);
    } catch (err) {
      toast({
        title: isEditing ? 'Failed to update tahsil' : 'Failed to add tahsil',
        description: err.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteTahsils = useCallback(
    (id) => {
      const tahsilToDelete = tahsils.find((t) => t._id === id);

      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this Tahsil!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1f580cff',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.isConfirmed) {
          setTahsils((prev) => prev.filter((t) => t._id !== id));
          setUndoTahsil(tahsilToDelete);

          const toastId = `delete-toast-${id}`;

          toast({
            id: toastId,
            position: 'bottom-left',
            duration: 5000,
            render: ({ onClose }) => (
              <Flex
                align="center"
                justify="space-between"
                p={3}
                bg="gray.700"
                color="white"
                borderRadius="md"
                boxShadow="lg"
              >
                <Text fontSize="sm" noOfLines={1} mr={3}>
                  "{tahsilToDelete.name}" deleted
                </Text>
                <Button
                  variant="ghost"
                  colorScheme="blue"
                  size="sm"
                  onClick={() => {
                    clearTimeout(deleteTimeouts.current[id]);
                    delete deleteTimeouts.current[id];

                    setTahsils((prev) =>
                      [...prev, tahsilToDelete].sort((a, b) =>
                        a.name.localeCompare(b.name),
                      ),
                    );
                    setUndoTahsil(null);
                    onClose();
                  }}
                >
                  Undo
                </Button>
                <CloseButton onClick={onClose} color="whiteAlpha.800" />
              </Flex>
            ),
          });

          deleteTimeouts.current[id] = setTimeout(async () => {
            try {
              await axios.delete(`${baseUrl}/master/delete-tahsil/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              setUndoTahsil(null);
            } catch (error) {
              toast({
                title: 'Error deleting Tahsil',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
            }
          }, 5000);
        }
      });
    },
    [token, toast, tahsils],
  );

  useEffect(() => {
    return () => {
      Object.values(deleteTimeouts.current).forEach(clearTimeout);
    };
  }, []);

  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const headerBg = useColorModeValue('#f9f9f9', 'gray.700');
  const rowHoverBg = useColorModeValue('#f1f5f9', 'gray.600');
  const boxBg = useColorModeValue('white', 'gray.900');
  const modalBg = useColorModeValue('white', 'gray.800');
  const modalFooterBg = useColorModeValue('gray.50', 'gray.700');
  const modalFooterBorder = useColorModeValue('gray.200', 'gray.600');
  const headingColor = useColorModeValue('blue.800', 'blue.200');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const boxShadow = useColorModeValue('md', 'dark-lg');

  const handleOpenModal = (tahsil = null) => {
    fetchDivisions();
    fetchDistricts();

    if (tahsil) {

      setIsEditing(true);
      setEditingId(tahsil._id);
      setNewTahsil(tahsil.name);
      setModalDivisionId(tahsil.division?._id || '');
      setModalDistrictId(tahsil.district?._id || '');
    } else {

      resetModalFields();
      setIsEditing(false);
      setEditingId(null);
    }

    onOpen();
  };

  return (
    <Box
      p={4}
      bg={boxBg}
      shadow={boxShadow}
      borderRadius="md"
      border="1px solid"
      borderColor={borderColor}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Flex align="center" gap={2}>
          <Icon as={FaBuildingColumns} boxSize={5} color="#4B80DE" />
          <Heading size="md">Tahsils</Heading>
        </Flex>
        <Tooltip label="Add Tahsil" hasArrow>
          <IconButton
            colorScheme="blue"
            size="sm"
            onClick={() => {
              resetModalFields();
              handleOpenModal();
            }}
            icon={<AddIcon />}
            aria-label="Add Tahsil"
            rounded="full"
            _hover={{ bg: 'blue.600' }}
          />
        </Tooltip>
      </Box>

      <Flex mb={4} gap={4} wrap="wrap">
        <InputGroup flex="1" size="sm" minW="250px" alignItems="center">
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.400" />
          </InputLeftElement>
          <Input
            height="32px"
            placeholder="Search Tahsil"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            color={inputTextColor}
          />
        </InputGroup>

        <Box flex="1" minW="250px">
          <Select
            options={districts.map((dist) => ({
              label: dist.name,
              value: dist._id,
            }))}
            value={
              districts.find((d) => d._id === districtId)
                ? {
                  label: `District: ${districts.find((d) => d._id === districtId).name
                    }`,
                  value: districtId,
                }
                : null
            }
            onChange={(selected) => setDistrictId(selected?.value || '')}
            placeholder="Select District"
            isClearable
            styles={selectStyles}
          />
        </Box>
      </Flex>

      <Box
        bg={useColorModeValue('white', 'gray.800')}
        rounded="lg"
        overflow="auto"
        maxH="260px"
        overflowY="auto"
        css={{
          '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#CBD5E0',
            borderRadius: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
        }}
      >
        <Table size="sm" variant="simple" minW="550px">
          <Thead
            position="sticky"
            top={0}
            zIndex={1}
            bgGradient="linear(to-r, blue.400, green.400)"
          >
            <Tr>
              <Th textAlign="center" fontSize="xs" color="white">
                Sr.No.
              </Th>
              <Th fontSize="xs" color="white">
                Tahsil
              </Th>
              <Th fontSize="xs" color="white">
                District
              </Th>
              <Th fontSize="xs" color="white">
                Division
              </Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tahsilLoading ? (
              Array.from({ length: 5 }).map((_, i) => (
                <Tr key={i}>
                  <Td textAlign="center">
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                </Tr>
              ))
            ) : tahsils.length === 0 ? (
              <Tr>
                <Td colSpan={4} textAlign="center" py={6}>
                  <Text color={textColor}>No Tahsils Found</Text>
                </Td>
              </Tr>
            ) : (
              tahsils.map((tahsil, index) => (
                <Tr key={tahsil._id} _hover={{ bg: rowHoverBg }}>
                  <Td textAlign="center" fontSize={'12px'}>
                    {index + 1}
                  </Td>
                  <Td fontSize={'12px'}>{tahsil.name.toUpperCase()}</Td>
                  <Td fontSize={'12px'}>
                    {tahsil.district?.name.toUpperCase()}
                  </Td>
                  <Td fontSize={'12px'}>
                    {tahsil.division?.name.toUpperCase()}
                  </Td>
                  <Td>
                    {/* <IconButton
                      icon={<RiDeleteBin2Line />}
                      aria-label="Delete"
                      variant="ghost"
                      size="sm"
                      color="red.500"
                      _hover={{ color: 'blue.600' }}
                      onClick={() => handleDeleteTahsils(tahsil._id)}
                    /> */}



                    {/* <IconButton
                      icon={<MdEditSquare />}
                      aria-label="Edit"
                      variant="solid"
                      size="sm"
                      colorScheme="blue"
                      isRound
                      onClick={() => handleOpenModal(tahsil)}
                    /> */}


                    <IconButton
                      icon={<MdEditSquare />}
                      aria-label="Edit"
                      variant="ghost"
                      size="sm"
                      color="blue.500"
                      _hover={{ bg: 'blue.50', color: 'blue.600' }}
                      onClick={() => handleOpenModal(tahsil)}
                    />
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent rounded="lg">
          <Box bg="blue.600" py={1} px={2}>
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              textAlign="center"
            >
              <Icon as={AddIcon} mr={2} />
              {isEditing ? 'Edit Tahsil' : 'Add New Tahsil'}
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>

          <ModalBody bg={modalBg} px={6} py={4}>
            <Text fontSize="lg" fontWeight="bold" color={headingColor} mb={4}>
              <Icon as={FaBuilding} mr={2} />
              Tahsil Details
            </Text>

            <FormControl isRequired w={'100%'}>
              <FormLabel>Division</FormLabel>
              <Select
                styles={selectStyles}
                options={divisions.map((div) => ({
                  label: div.name,
                  value: div._id,
                }))}
                value={
                  divisions.find((d) => d._id === modalDivisionId)
                    ? {
                      label: divisions.find((d) => d._id === modalDivisionId)
                        .name,
                      value: modalDivisionId,
                    }
                    : null
                }
                onChange={(selected) => {
                  setModalDivisionId(selected?.value || '');
                  setModalDistrictId('');
                }}
                placeholder="Select Division"
                isClearable
              />
            </FormControl>

            <FormControl isRequired w={'100%'} mt={4}>
              <FormLabel>District</FormLabel>
              <Select
                options={modalDistricts.map((dist) => ({
                  label: dist.name,
                  value: dist._id,
                }))}
                value={
                  modalDistricts.find((d) => d._id === modalDistrictId)
                    ? {
                      label: modalDistricts.find(
                        (d) => d._id === modalDistrictId,
                      ).name,
                      value: modalDistrictId,
                    }
                    : null
                }
                onChange={(selected) =>
                  setModalDistrictId(selected?.value || '')
                }
                placeholder="Select District"
                isClearable
                isDisabled={!modalDivisionId}
                styles={selectStyles}
              />
            </FormControl>

            <FormControl isRequired w={'100%'} mt={4}>
              <FormLabel>Tahsil Name</FormLabel>
              <Input
                placeholder="Enter Tahsil Name"
                value={newTahsil}
                onChange={(e) => setNewTahsil(e.target.value)}
                color={inputTextColor}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter bg={modalFooterBg} borderColor="gray.200">
            <Button variant="ghost" colorScheme="red" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSaveTahsil}
              isLoading={loading}
            >
              <Icon as={AddIcon} mr={2} />
              {isEditing ? 'Update Tahsil' : 'Add Tahsil'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TahsilSection;
